import Cookies from 'universal-cookie'
import { push } from 'react-router-redux'
import qs from 'query-string'

import createConstant from '../../utils/createConst'
import { API_HOSTNAME } from '../../GlobalConfig'

const LOGIN = createConstant('user/LOGIN')
const LOGOUT = createConstant('user/LOGOUT')
const REGISTER = createConstant('user/REGISTER')
const VERIFY_TOKEN = createConstant('user/VERIFY_TOKEN')
const UPDATE_PROFILE = createConstant('user/UPDATE_PROFILE')
const SEND_OTP = createConstant('user/SEND_OTP')
const RESEND_OTP = createConstant('user/RESEND_OTP')
const RESET_PASSWORD = createConstant('user/RESET_PASSWORD')
const GET_CITY = createConstant('user/GET_CITY')
const GET_PROVINCES = createConstant('user/GET_PROVINCES')
const TAMP_EMAIL = 'TAMP_EMAIL'
const UPDATE_AVATAR = createConstant('user/UPDATE_AVATAR')

const cookies = new Cookies()

const initialState = {
  data: undefined,
  isLoggedIn: false,
  loginRequest: false,
  errorLogin: '',
  errorVerify: '',
  registerRequest: false,
  errorRegister: '',
  successRegister: '',
  UpdateProfileRequest: false,
  errorUpdateProfile: '',
  successUpdateProfile: '',
  UpdatePasswordRequest: false,
  errorUpdatePassword: '',
  successUpdatePassword: '',
  tampEmail: '',
  otpRequest: false,
  otp: undefined,
  errorOtp: '',
  updateAvatarRequest: false,
  provinces: undefined,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOGIN.request:
      return {
        ...state,
        loginRequest: true,
      }
    case LOGIN.failed:
      return {
        ...state,
        loginRequest: false,
        data: undefined,
        isLoggedIn: false,
        errorLogin: action.error.message,
      }
    case LOGIN.success:
      cookies.set('TKN_MINAPOLI', action.result.result.token, { path: '/', maxAge: 86400 })
      return {
        ...state,
        loginRequest: false,
        data: action.result.result.user,
        isLoggedIn: true,
        errorLogin: '',
      }
    case LOGOUT.request:
      return {
        ...state,
        logoutRequest: true,
      }
    case LOGOUT.failed:
      return {
        ...state,
        logoutRequest: false,
        isLoggedIn: true,
        errorLoggout: action.error.message,
      }
    case LOGOUT.success:
      cookies.remove('TKN_MINAPOLI', { path: '/' })
      return {
        ...state,
        logoutRequest: false,
        data: undefined,
        isLoggedIn: false,
        errorLoggout: '',
      }
    case RESEND_OTP.request:
      return {
        ...state,
        resendOTPRequest: true,
      }
    case RESEND_OTP.failed:
      return {
        ...state,
        resendOTPRequest: false,
        resendOTP: false,
        resendOTPError: 'Gagal Mengirim OTP, silahkan coba lagi.',
      }
    case RESEND_OTP.success:
      return {
        ...state,
        resendOTPRequest: false,
        resendOTP: true,
        resendOTPError: '',
      }
    case TAMP_EMAIL:
      return {
        ...state,
        tampEmail: action.payload,
      }
    case REGISTER.request:
      return {
        ...state,
        registerRequest: true,
      }
    case REGISTER.failed:
      return {
        ...state,
        registerRequest: false,
        errorRegister: Object.keys(action.error.errors).reduce((sum, key) => {
          const text = action.error.errors[key].join(' ')

          return sum + text
        }, ''),
      }
    case REGISTER.success:
      return {
        ...state,
        registerRequest: false,
        errorRegister: '',
        errorLogin: '',
        successRegister: action.result.message,
      }
    case SEND_OTP.request:
      return {
        ...state,
        otpRequest: true,
      }
    case SEND_OTP.failed:
      return {
        ...state,
        otpRequest: false,
        otp: false,
        errorOtp: action.error.message,
      }
    case SEND_OTP.success:
      return {
        ...state,
        otpRequest: false,
        otp: true,
        errorOtp: '',
        errorLogin: '',
        errorRegister: '',
      }
    case VERIFY_TOKEN.success:
      return {
        ...state,
        data: action.result.result.user,
        isLoggedIn: true,
      }
    case UPDATE_PROFILE.request:
      return {
        ...state,
        updateProfileRequest: true,
      }
    case UPDATE_PROFILE.failed:
      return {
        ...state,
        updateProfileRequest: false,
        errorUpdateProfile: action.error.message,
      }
    case UPDATE_PROFILE.success:
      return {
        ...state,
        data: { ...state.data, ...action.result.result.user },
        updateProfileRequest: false,
        errorUpdateProfile: '',
        successUpdateProfile: action.result.message,
      }
    case RESET_PASSWORD.request:
      return {
        ...state,
        updatePasswordRequest: true,
      }
    case RESET_PASSWORD.failed:
      return {
        ...state,
        updatePasswordRequest: false,
        errorUpdatePassword: action.error.message,
      }
    case RESET_PASSWORD.success:
      return {
        ...state,
        updatePasswordRequest: false,
        errorUpdatePassword: '',
        successUpdatePassword: 'Berhasil mengganti password Anda.',
      }
    case GET_CITY.request:
      return {
        ...state,
        getCityRequest: true,
        city: undefined,
      }
    case GET_CITY.success:
      return {
        ...state,
        getCityRequest: false,
        city: action.result.result,
      }
    case GET_CITY.failed:
      return {
        ...state,
        getCityRequest: false,
      }
    case GET_PROVINCES.request:
      return {
        ...state,
      }
    case GET_PROVINCES.success:
      return {
        ...state,
        provinces: action.result.result,
      }
    case GET_PROVINCES.failed:
      return {
        ...state,
      }
    case UPDATE_AVATAR.request:
      return {
        ...state,
        updateAvatarRequest: true,
      }
    case UPDATE_AVATAR.failed:
      return {
        ...state,
        updateAvatarRequest: false,
      }
    case UPDATE_AVATAR.success:
      return {
        ...state,
        data: action.result.result,
        updateAvatarRequest: false,
      }
    default:
      return state
  }
}

export const doLogin = payload => (dispatch) => {
  dispatch({
    type: TAMP_EMAIL,
    payload: payload.email,
  })
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    mode: 'cors',
    body: JSON.stringify(payload),
  }

  dispatch({
    types: LOGIN,
    promise: fetch(`${API_HOSTNAME}/v1/auth/login`, options),
  })
}

export const sendOTP = (payload) => {
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    mode: 'cors',
    body: JSON.stringify(payload),
  }

  return {
    types: SEND_OTP,
    promise: fetch(`${API_HOSTNAME}/v1/check_otp`, options),
  }
}

export const resendOTP = (payload) => {
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    mode: 'cors',
    body: JSON.stringify({
      email: payload,
    }),
  }

  return {
    types: RESEND_OTP,
    promise: fetch(`${API_HOSTNAME}/v1/resend_otp`, options),
  }
}

export const doRegister = payload => (dispatch) => {
  dispatch({
    type: TAMP_EMAIL,
    payload: payload.email,
  })
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    mode: 'cors',
    body: JSON.stringify(payload),
  }
  dispatch({
    types: REGISTER,
    promise: fetch(`${API_HOSTNAME}/v1/register`, options),
  })
}

export const verifyTokenAction = payload => ({
  type: VERIFY_TOKEN.success,
  result: payload,
})

export const doUpdateProfile = (payload) => {
  const auth = cookies.get('TKN_MINAPOLI')

  if (auth) {
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${auth}`,
      },
      mode: 'cors',
      body: JSON.stringify(payload),
    }

    return {
      types: UPDATE_PROFILE,
      promise: fetch(`${API_HOSTNAME}/v1/user/update_profile`, options),
    }
  }

  console.error('Not Authorized')

  return null
}

export const doLogout = () => (dispatch) => {
  const cookie = new Cookies()
  const token = cookie.get('TKN_MINAPOLI')
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    mode: 'cors',
  }

  dispatch(push('/'))
  dispatch({
    types: LOGOUT,
    promise: fetch(`${API_HOSTNAME}/v1/auth/logout`, options),
  })
}

export const doUpdatePassword = (variables) => {
  const token = cookies.get('TKN_MINAPOLI')
  const formData = new FormData()

  Object.keys(variables).forEach((key) => {
    formData.append(key, variables[key])
  })

  const options = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    mode: 'cors',
    body: formData,
  }

  return {
    types: RESET_PASSWORD,
    promise: fetch(`${API_HOSTNAME}/v1/user/password/change`, options),
  }
}

export const getCity = (limit = 541, query) => ({
  types: GET_CITY,
  promise: fetch(`${API_HOSTNAME}/v1/city/indonesia?limit=${limit}&q=${query}`),
})

export const getProvinces = (limit = 541, query) => ({
  types: GET_PROVINCES,
  promise: fetch(`${API_HOSTNAME}/v1/get_province/indonesia?limit=${limit}&q=${query}`),
})

export const doUpdateAvatar = (formData) => {
  const auth = cookies.get('TKN_MINAPOLI')

  if (auth) {
    const options = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${auth}`,
      },
      mode: 'cors',
      body: formData,
    }

    return {
      types: UPDATE_AVATAR,
      promise: fetch(`${API_HOSTNAME}/v1/user/picture/update`, options),
    }
  }

  console.error('Not Authorized')

  return null
}



// WEBPACK FOOTER //
// ./src/modules/User/index.js